import React from "react";
import CSSModules from "lib/utils/css-modules";
import { bindActionCreators } from "redux";
import { Button, Form, FormControl, Grid, AppSettings } from "lib/index";
import StWidget, { widgetJsCode, widgetComponentCode } from "./StWidget";
import WidgetRouteFormSection, { buildRouteParams } from "./WidgetRouteFormSection";
import styles from "./WidgetsSettingsView.less";
import { createWidget, updateWidget, initializeView } from "./index";
import { connect } from "react-redux";
import store from "app/store";
import { createAlert, removeAlert } from "modules/app/actions";

@connect(
  (state) => ({
    currentCompany: state.auth.company.model,
    widgets: state.settings.WidgetsSettingsView,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class BubbleWidgetView extends React.Component {
  constructor(...args) {
    super(...args);
    const { company, products, marketplace } = this.props;
    this.state = {
      isWidgetsLoaded: false,
      isSaveDisabled: false,
      hasChanged: false,
      showCode: true,
      widget: {
        options: {
          showCode: false,
          routeParams: buildRouteParams({ company, products, marketplace }),
          line1: I18n.t("papp.settings.BubbleWidgetView.balloon_line1_value"),
          line2: I18n.t("papp.settings.BubbleWidgetView.balloon_line2_value"),
          color: "teal",
          size: "normal",
          placement: "bottomRight",
          showAfter: 3000,
          showBalloonAfter: 5000,
          locale: null,
          currency: null,
          active: false,
          animation_type: null,
          icon: "percentage",
          scrollWidget: true,
          pulsate: true,
          exitWidget: true,
          openInModal: true,
        },
        widget_type: "bubble",
      },
    };
  }

  componentDidMount() {
    this.initialiseWidget();
  }
  componentDidUpdate() {
    this.initialiseWidget();
  }
  initialiseWidget = () => {
    if (!this.state.isWidgetsLoaded) {
      const w = this.getWidget(this.props.widgets);
      if (w) {
        this.setState((prevstate) => ({
          ...prevstate,
          widget: w,
        }));
      }
    }
  };

  getWidget(state) {
    let widget = null;
    if (state.widgets && state.widgets.data) {
      this.setState((prevstate) => ({
        ...prevstate,
        isWidgetsLoaded: true,
      }));
      for (let w of state.widgets.data) {
        if (w.attributes.widget_type === "bubble") {
          widget = w.attributes;
          break;
        }
      }
    }
    return widget;
  }

  onButtonClick = () => {
    this.setState((prevstate) => ({
      ...prevstate,
      hasChanged: false,
      isSaveDisabled: true,
    }));

    let widgetDTO = { ...this.state.widget };
    widgetDTO.options.href = widgetDTO.options.routeParams.url;
    if (this.state.widget.id) {
      updateWidget({ widget: widgetDTO }).subscribe(() => {
        store.dispatch(
          createAlert({
            type: "success",
            content: I18n.t("papp.common.submit_success_message"),
            timeout: 3000,
          })
        );
        this.unlockSave();
      });
    } else {
      createWidget({ widget: widgetDTO })
        .toPromise()
        .then((w) => {
          this.setState((prevstate) => ({
            ...prevstate,
            widget: w.data.data.attributes,
          }));
          this.props.initializeView();
          this.unlockSave();
        });
    }
  };

  unlockSave = () => {
    this.setState((prevstate) => ({
      ...prevstate,
      isSaveDisabled: false,
    }));
  };

  updateWidgetState = (name, val) => {
    let newState = Object.assign({}, this.state);
    newState.widget.options[name] = val;
    newState.hasChanged = true;
    if (name === "active") {
      newState.widget.active = val;
    }
    this.setState(newState);
  };

  render() {
    const { company, products, marketplace } = this.props;
    const {
      routeParams,
      line1,
      line2,
      color,
      size,
      placement,
      showAfter,
      showBalloonAfter,
      locale,
      currency,
      active,
      animation_type,
      icon,
      exitWidget,
      scrollWidget,
      openInModal,
    } = this.state.widget.options;
    const { showCode, hasChanged, isSaveDisabled } = this.state;
    const colorOptions = [
      ["blue", I18n.t("papp.settings.NavBarWidgetView.blue")],
      ["teal", I18n.t("papp.settings.NavBarWidgetView.teal")],
      ["orange", I18n.t("papp.settings.NavBarWidgetView.orange")],
      ["black", I18n.t("papp.settings.NavBarWidgetView.black")],
      ["green", I18n.t("papp.settings.NavBarWidgetView.green")],
      ["red", I18n.t("papp.settings.NavBarWidgetView.red")],
    ];
    const animation_typeOptions = [
      ["type1", I18n.t("papp.settings.NavBarWidgetView.type1")],
      ["type2", I18n.t("papp.settings.NavBarWidgetView.type2")],
      ["type3", I18n.t("papp.settings.NavBarWidgetView.type3")],
    ];
    const sizeOptions = [
      ["small", I18n.t("papp.settings.BubbleWidgetView.small_size")],
      ["normal", I18n.t("papp.settings.BubbleWidgetView.normal_size")],
      ["large", I18n.t("papp.settings.BubbleWidgetView.large_size")],
    ];
    const placementOptions = [
      ["bottomRight", I18n.t("papp.settings.BubbleWidgetView.bottom_right_corner")],
      ["bottomLeft", I18n.t("papp.settings.BubbleWidgetView.bottom_left_corner")],
      ["topRight", I18n.t("papp.settings.BubbleWidgetView.top_right_corner")],
      ["topLeft", I18n.t("papp.settings.BubbleWidgetView.top_left_corner")],
    ];
    const iconOptions = [
      ["percentage", I18n.t("papp.settings.NavBarWidgetView.percentage")],
      ["activity", I18n.t("papp.settings.NavBarWidgetView.activity")],
      ["cart", I18n.t("papp.settings.NavBarWidgetView.cart")],
      ["notification", I18n.t("papp.settings.NavBarWidgetView.notification")],
      // ["offer", I18n.t("papp.settings.NavBarWidgetView.offer")],
      ["search", I18n.t("papp.settings.NavBarWidgetView.search")],
      ["star", I18n.t("papp.settings.NavBarWidgetView.star")],
      ["negotiate", I18n.t("papp.settings.NavBarWidgetView.negotiate")],
      ["discount", I18n.t("papp.settings.NavBarWidgetView.discount")],
      ["chat", I18n.t("papp.settings.NavBarWidgetView.chat")],
    ];

    const openInModalOptions = [
      ["__stModal", I18n.t("papp.settings.ButtonWidgetView.in_modal")],
      ["_blank", I18n.t("papp.settings.ButtonWidgetView.in_new_tab")],
    ];

    const widgetProps = {
      component: "Bubble",
      icon,
      href: routeParams.url,
      line1,
      line2,
      color,
      animation_type,
      size,
      placement,
      showAfter,
      showBalloonAfter,
      exitWidget,
      scrollWidget,
      openInModal,
    };

    return (
      <div>
        {this.state.isWidgetsLoaded && (
          <div styleName="widget-container">
            <div styleName="widget-form">
              <Form>
                <h3>{I18n.t("papp.settings.BubbleWidgetView.title")}</h3>

                <Grid columns={2}>
                  <Grid.Column>
                    <FormControl.Checkbox
                      label={I18n.t("papp.settings.WidgetsSettingsView.active")}
                      checked={!!active}
                      onChange={(checked) => this.updateWidgetState("active", checked ? true : false)}
                      toggle
                    />{" "}
                    <br />
                    <br />
                    <FormControl.Checkbox
                      label={I18n.t("papp.settings.WidgetsSettingsView.exitWidget")}
                      checked={!!exitWidget}
                      onChange={(checked) => this.updateWidgetState("exitWidget", checked ? true : false)}
                      toggle
                    />
                    <br />
                    <br />
                    <FormControl.Checkbox
                      label={I18n.t("papp.settings.WidgetsSettingsView.scrollWidget")}
                      checked={!!scrollWidget}
                      onChange={(checked) => this.updateWidgetState("scrollWidget", checked ? true : false)}
                      toggle
                    />
                    <WidgetRouteFormSection
                      company={company}
                      products={products}
                      marketplace={marketplace}
                      locale={locale}
                      currency={currency}
                      value={routeParams}
                      onChange={(routeParams) => this.updateWidgetState("routeParams", routeParams)}
                    />
                    <br />
                    <FormControl.LocaleSelectFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.WidgetsSettingsView.locale")}
                      value={locale}
                      onChange={(locale) => this.updateWidgetState("locale", locale)}
                      locales="customer_locales"
                      includeBlank
                      placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
                    />
                    <FormControl.SelectFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.WidgetsSettingsView.currency")}
                      value={currency}
                      onChange={(currency) => this.updateWidgetState("currency", currency)}
                      options={AppSettings.frontend_currencies.filter(
                        (currency) => !["GBP", "TRY"].includes(currency)
                      )}
                      includeBlank
                      placeholder={I18n.t("papp.settings.WidgetsSettingsView.detect_from_visitor_browser")}
                    />
                    <FormControl.InputFormGroup
                      label={I18n.t("papp.settings.BubbleWidgetView.balloon_line1_label")}
                      value={line1}
                      onChange={(line1) => this.updateWidgetState("line1", line1)}
                    />
                    <FormControl.InputFormGroup
                      label={I18n.t("papp.settings.BubbleWidgetView.balloon_line2_label")}
                      value={line2}
                      onChange={(line2) => this.updateWidgetState("line2", line2)}
                    />
                    <FormControl.MultipleRadioFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.ButtonWidgetView.open")}
                      value={openInModal ? "__stModal" : "_blank"}
                      onChange={(v) => this.updateWidgetState("openInModal", v === "__stModal" ? true : false)}
                      options={openInModalOptions}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <FormControl.SelectFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.BubbleWidgetView.color_label")}
                      value={color}
                      onChange={(color) => this.updateWidgetState("color", color)}
                      options={colorOptions}
                    />

                    {/* <FormControl.SelectFormGroup
                      inlineLabel
                      inline
                      label={I18n.t(
                        "papp.settings.BubbleWidgetView.animation_type"
                      )}
                      value={animation_type}
                      onChange={animation_type =>
                        this.updateWidgetState("animation_type", animation_type)
                      }
                      options={animation_typeOptions}
                    /> */}

                    <FormControl.SelectFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.BubbleWidgetView.icon")}
                      value={icon}
                      onChange={(icon) => this.updateWidgetState("icon", icon)}
                      options={iconOptions}
                    />

                    <FormControl.MultipleRadioFormGroup
                      inlineLabel
                      inline
                      label={I18n.t("papp.settings.BubbleWidgetView.size_label")}
                      value={size}
                      onChange={(size) => this.updateWidgetState("size", size)}
                      options={sizeOptions}
                    />

                    <FormControl.SelectFormGroup
                      inlineLabel
                      label={I18n.t("papp.settings.BubbleWidgetView.placement_label")}
                      value={placement}
                      onChange={(placement) => this.updateWidgetState("placement", placement)}
                      options={placementOptions}
                      className="u-mediumWidth"
                    />

                    <FormControl.InputFormGroup
                      inlineLabel
                      type="number"
                      min={0}
                      step={1}
                      label={I18n.t("papp.settings.BubbleWidgetView.show_after_label")}
                      value={showAfter / 1000}
                      onChange={(showAfter) => {
                        this.updateWidgetState("showAfter", Math.round(+(showAfter || 0) * 1000));
                      }}
                      inputLabel="s"
                    />

                    <FormControl.InputFormGroup
                      inlineLabel
                      type="number"
                      min={0}
                      step={1}
                      label={I18n.t("papp.settings.BubbleWidgetView.show_balloon_after_label")}
                      value={showBalloonAfter / 1000}
                      onChange={(showBalloonAfter) => {
                        this.updateWidgetState("showBalloonAfter", Math.round(+(showBalloonAfter || 0) * 1000));
                      }}
                      inputLabel="s"
                    />
                  </Grid.Column>
                </Grid>

                <br />

                <Button
                  primary
                  as="a"
                  onClick={this.onButtonClick}
                  disabled={!hasChanged || isSaveDisabled}
                  content={I18n.t("papp.settings.BubbleWidgetView.generate_code")}
                />
              </Form>
            </div>

            <hr />

            <div styleName="widget-example">
              <h3>{I18n.t("papp.settings.BubbleWidgetView.preview")}</h3>
              <StWidget widgetProps={widgetProps} />
            </div>
          </div>
        )}
        <p />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/BubbleWidgetView.jsx